import { SxProps } from "@mui/material"
import cn from "classnames"
import React, { useLayoutEffect, useRef, useState } from "react"
import { InputComponent, InputTypography } from "./styled"

type Props = {
  sx?: SxProps,
  className?: string,
  defaultValue?: string,
  placeholder?: string,
  value?: string,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const EditableText = ({ className, sx, defaultValue, placeholder, value, onChange }: Props) => {

  const inputRef = useRef<HTMLInputElement>(null)
  const typoRef = useRef<HTMLDivElement>(null)
  const [ _value, _setValue ] = useState(defaultValue || "")
  const [ editMode, setEditMode ] = useState(false)

  const onDoubleClick = (e: MouseEvent) => {
    e.stopPropagation()
    setEditMode(true)
  }

  useLayoutEffect(() => {
    if (editMode) {
      inputRef.current?.select()
    } else {
      const el = typoRef.current
      if (!el) return
      el.addEventListener("dblclick", onDoubleClick)
      return () => {
        el.removeEventListener("dblclick", onDoubleClick)
      }
    }
  }, [ editMode ])

  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.code === "Enter") {
      e.stopPropagation()
      e.preventDefault()
      setEditMode(false)
    }
  }

  if (editMode) {
    return (
      <InputComponent 
        className={className} 
        sx={sx} 
        value={ onChange? value: _value } 
        onChange={ onChange || (e => _setValue(e.target.value))}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        ref={inputRef}
        onBlur={() => setEditMode(false)}
      />
    )
  }

  return (
    <InputTypography 
      className={cn(className, "editable")} 
      sx={sx} 
      empty={!(onChange? value: _value)} 
      ref={typoRef}
    >
      { (onChange? value: _value) || placeholder }
    </InputTypography>
  )
}

export default EditableText